import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategoryNav() {
  return (
    <section className="w-full py-8 md:py-12 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-6 text-center">
          探索精彩内容
        </h2>
        <div className="flex flex-wrap justify-center gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-700 text-sm font-medium transition-colors cursor-pointer border border-background-200 hover:border-primary-200"
            >
              <i className={`${cat.icon} text-base`}></i>
              <span className="whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}